import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { initAnalytics } from './utils/analytics.ts'

// Before React renders, so the first pageview and the session replay both start
// at the top of the visit rather than after the app shell settles.
initAnalytics()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  integrations: [Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] })],
  enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Algo deu errado.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
